import { createElement } from 'react';
import classNames from 'classnames';
const classPrefix = `au-dragbar-mark`;
const Marks = ({ marks, max, min }) => {
    const marksKeys = marks;
    const range = max - min;
    const elements = marksKeys
        .sort((a, b) => a - b)
        .filter(point => point >= min && point <= max)
        .map((point, index) => {
        const markPoint = marks[index];
        if (!markPoint && markPoint !== 0) {
            return null;
        }
        const markClassName = classNames({
            [`${classPrefix}-text`]: true,
        });
        const style = {
            left: `${((point - min) / range) * 100}%`,
        };
        return (createElement("span", { className: markClassName, style: style, key: point }, markPoint));
    });
    return createElement("div", { className: classPrefix }, elements);
};
export default Marks;
